import { navyBlue, navyBlueWithOpacity } from "@/angelouCE/utils/constants";

export const progressBarCss = {
  height: "6px",
  display: "flex",
  justifyContent: "space-between",
};

export const stepCss = (count, isComplete) => ({
  height: "100%",
  backgroundColor: isComplete ? navyBlue : navyBlueWithOpacity,
  width: `${100 / count}%`,
  "&:not(:last-child)": {
    marginRight: "5px",
  },
});
